<div class="jumbotron text-center">
    <h1 class="display-3" style="margin-top: 50px">404 - Page Not Found</h1>
    <p class="lead" style="margin-top: 30px">The content you are looking for could not be found or does not exist.</p>
    <hr>
    <p style="margin-bottom: 30px; margin-top: 25px;">
      Believe you have received this message in error? <a href="mailto:support@regscale.com">Contact our tech support</a> to report any issues.
    </p>
    <p class="lead">
      <a class="btn btn-primary btn-sm" [routerLink]="['/home']" role="button">Return to Homepage</a>
    </p>
  </div>

